import { Input } from '@any-ui-react/core';
import type { ReactNode } from 'react';

import { HoverCardWithIcon } from '@/common/components/shared/hover-card/HoverCardWithIcon';

interface Props {
  showInTooltip?: boolean;
  label: string;
  description: ReactNode;
  required?: boolean;
  htmlFor?: string;
}

export const FieldLabel = ({ showInTooltip, label, description, required, htmlFor }: Props) => {
  if (showInTooltip) {
    return (
      <div className="flex items-center">
        <Input.Label className="mr-1" htmlFor={htmlFor} required={required}>
          {label}
        </Input.Label>
        <HoverCardWithIcon>{description}</HoverCardWithIcon>
      </div>
    );
  }

  return (
    <>
      <Input.Label htmlFor={htmlFor} required={required}>
        {label}
      </Input.Label>
      <p className="mb-1 text-2xs leading-8 text-gray-7">{description}</p>
    </>
  );
};
